<div [formGroup]="form" class="form-group" [ngClass]="field?.styleClass">
  <ng-container *ngIf="isPasswordField(); else defaultInput">
    <app-password-input
      [control]="form.get(field.name)"
      [label]="field.label || ''"
      [required]="!!field.validation?.required"
      [infoMessage]="field.infoIconMessage"
      [inputId]="field.name"
      [autocomplete]="field.autoComplete || 'on'"
      [maxLength]="field.maxlength || null"
      [inputClass]="{ 'disable-input': field.disabled }"
      (keydownEvent)="field.onKeyDown && field.onKeyDown($event)"
      (blurEvent)="trimInputValue()"
      (pasteEvent)="preventPaste($event)"
      (focusEvent)="handleFocus()"
    ></app-password-input>
  </ng-container>

  <ng-template #defaultInput>
    <label
      *ngIf="field.label"
      [ngClass]="{
        'mb-12': field?.textLogoUrl
      }"
    >
      <img
        appMobileOptimization
        [originalUrl]="field?.textLogoUrl"
        *ngIf="field?.textLogoUrl"
        class="text-logo-img"
        [src]="field?.textLogoUrl"
        [format]="'webp'"
        alt="logo"
        loading="lazy"
        decoding="async"
      />
      {{ field.label }}{{ field.validation?.required ? '*' : '' }}
      <app-info-icon
        [message]="field.infoIconMessage"
        *ngIf="field.infoIconMessage"
      ></app-info-icon>
      <span class="sub-label" *ngIf="field.subLabel">
        &nbsp;{{ field.subLabel }}
      </span>
    </label>

  <div
    class="input-container"
    [ngClass]="{
      'prefix-input': !!(field.prefix || field.prefixImageUrl),
      'flex-border': field.socialMediaPrefix
    }"
  >
    <div
      *ngIf="field?.socialMediaPrefix"
      class="social-media-handle form-control"
    >
      <div class="handle">
        <img
          *ngIf="!field.socialMediaPrefix?.iconClass"
          class="icon"
          appDisableRightClick
          appMobileOptimization
          [originalUrl]="field.socialMediaPrefix?.iconPath"
          [src]="field.socialMediaPrefix?.iconPath"
          [format]="'webp'"
          alt="Social Media Icon"
          loading="lazy"
          decoding="async"
        />
        <div class="icon-container" *ngIf="field.socialMediaPrefix?.iconClass">
          <em [ngClass]="field.socialMediaPrefix?.iconClass"></em>
        </div>
        <p class="name">{{ field.socialMediaPrefix?.name }}</p>
      </div>
    </div>
    <div class="prefix-content">
      <div
        class="form-control predefined-url"
        [ngClass]="{ 'pad-right-0': !!field.socialMediaPrefix }"
        *ngIf="field?.socialMediaPrefix"
      >
        <span class="span">{{ field?.socialMediaPrefix.url }}</span>
      </div>
      <input
        *ngIf="field.addSsnDirective"
        [type]="field.type"
        [autocomplete]="field.autoComplete || 'on'"
        class="form-control"
        [ngClass]="{ 'pad-left-0': !!field.socialMediaPrefix }"
        [maxlength]="field.maxlength"
        [formControlName]="field.name"
        appSsnMask
        [placeholder]="field.placeholder || ''"
        (blur)="trimInputValue()"
        (wheel)="disableScroll($event)"
      />
      <input
        *ngIf="!field.addSsnDirective"
        [id]="field.name"
        [type]="inputType"
        [autocomplete]="field.autoComplete || 'on'"
        [ngStyle]="{
          'padding-left':
            (field.prefix || field.prefixImageUrl) && field.prefixLength
              ? field.prefixLength
              : '',
          'padding-right': field.suffixButton ? '62px' : ''
        }"
        class="form-control"
        [ngClass]="{ 'pad-left-0': !!field.socialMediaPrefix, 'disable-input': field.disabled }"
        [maxlength]="field.maxlength"
        [formControlName]="field.name"
        [placeholder]="field.placeholder || ''"
        (keydown)="field.onKeyDown && field.onKeyDown($event)"
        (blur)="trimInputValue()"
        (wheel)="disableScroll($event)"
        (paste)="preventPaste($event)"
        (focus)="handleFocus()"
        [disabled]="field.disabled"
      />
      <div *ngIf="field.infoIconInputMessage" class="input-info">
        <app-info-icon [message]="field.infoIconInputMessage"></app-info-icon>
      </div>

      <div *ngIf="field.prefix" class="prefix">
        {{ field.prefix }}
      </div>
      <div *ngIf="field.prefixImageUrl" class="prefix-image">
        <img
          [src]="field.prefixImageUrl"
          [alt]="field.prefixImageAlt || ''"
          width="24"
          height="24"
          loading="lazy"
          decoding="async"
        />
      </div>
      <button 
        *ngIf="field.suffixButton" 
        type="button" 
        class="suffix-btn"
        [ngClass]="field.suffixButton.styleClass"
        [class.disable]="isSuffixButtonDisabled()"
        [disabled]="isSuffixButtonDisabled()"
        (click)="field.suffixButton.onClick()"
      >
        <em *ngIf="field.suffixButton.iconClass" [ngClass]="field.suffixButton.iconClass"></em>
        <span *ngIf="field.suffixButton.label">{{ field.suffixButton.label }}</span>
      </button>
    </div>
  </div>
  </ng-template>
  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
